<h2 mat-dialog-title>{{ isEdit ? 'Edit number range' : 'New number range' }}</h2>
<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="number-range-form">
    <mat-form-field>
      <mat-label>Key</mat-label>
      <input matInput formControlName="key" required>
      @if (form.controls.key.hasError('required') || form.controls.key.hasError('pattern')) {
        <mat-error>Key is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Min</mat-label>
      <input matInput type="number" step="1" formControlName="min" required>
      <mat-error>Whole number required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Max</mat-label>
      <input matInput type="number" step="1" formControlName="max" required>
      <mat-error>Whole number required</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Actual</mat-label>
      <input matInput type="number" step="1" formControlName="actual" required>
      <mat-error>Whole number required</mat-error>
    </mat-form-field>

    @if (form.hasError('minGreaterThanMax')) {
      <p class="number-range-form__error">Min must not be greater than max.</p>
    }
    @if (form.hasError('actualOutOfRange')) {
      <p class="number-range-form__error">Actual must be between min and max.</p>
    }
    @if (errorMessage) {
      <p class="number-range-form__error">{{ errorMessage }}</p>
    }
    @if (saving) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="saving || form.invalid">Save</button>
  </mat-dialog-actions>
</form>
